import { type ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

type Props = {
  children: ReactNode
  className?: string
}

export default function Container(props: Props) {
  return (
    <div
      className={twMerge('mx-auto mt-6 max-w-screen-lg px-4', props.className)}
    >
      {props.children}
    </div>
  )
}
